// GlobalModal.js
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const GlobalModal = ({
  show,
  onHide,
  type,       // "error", "success", "warning", or "confirmation"
  title,
  message,
  onConfirm,  // Function to call on confirm action
  onCancel,   // Function to call on cancel action
}) => {
  // Determine default title and button variant based on type
  const defaultTitle = {
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    confirmation: 'Confirm Action'
  }[type] || 'Notification';

  const buttonVariant = {
    error: 'danger',
    success: 'success',
    warning: 'warning',
    confirmation: 'primary'
  }[type] || 'primary';

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || defaultTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message}
      </Modal.Body>
      <Modal.Footer>
        {(type === 'confirmation' || type === 'warning') ? (
          <>
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant={buttonVariant} onClick={onConfirm}>
              Confirm
            </Button>
          </>
        ) : (
          <Button variant={buttonVariant} onClick={onHide}>
            Ok
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default GlobalModal;
